const prefix = process.env.REACT_APP_CMS_FILE_STORAGE || 'http://localhost:9000/ms-cms/api/v2/media/download';

export const getMediaURL = (src) => {
  if (src.startsWith('http'))
    return src;

  return `${prefix}${src.startsWith('/')?'':'/'}${src}`;
};
